//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface State {
    activityList: any
    analytics: any
    /////////////////
    history: any
    userRewards: any
    chartAnalytics: any
}

const initialState: State = {
    activityList: null,
    analytics: null,
    /////////////////
    history: { data: { list: [], paginate: {} } },
    userRewards: null,
    chartAnalytics: []
}

const slice = createSlice({
    name: "referralLink",
    initialState,
    reducers: {
        setActivityList: (state, action: PayloadAction<any>) => {
            return { ...state, activityList: action.payload }
        },
        setAnalytics: (state, action: PayloadAction<any>) => {
            return { ...state, analytics: action.payload }
        },
        /////////////////
        setHistory: (state, action: PayloadAction<any>) => {
            return { ...state, history: action.payload }
        },
        setUserRewards: (state, action: PayloadAction<any>) => {
            return { ...state, userRewards: action.payload }
        },
        setChartAnalytics: (state, action: PayloadAction<any>) => {
            return { ...state, chartAnalytics: action.payload }
        }
    },
})

export const { setActivityList, setAnalytics, setHistory, setUserRewards, setChartAnalytics } = slice.actions
export const selectReferral = (state: { referral: State }) => state.referral
export default slice.reducer
